import { SvgIcon, SvgIconProps } from "@mui/material";

export const TeamMembersIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="team-members"
    >
      <circle
        cx="8.5"
        cy="8.999"
        r="3"
        stroke="#6FAFE9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.499"
      />
      <circle
        cx="15.998"
        cy="9.999"
        r="2"
        stroke="#6FAFE9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.499"
      />
      <path
        stroke="#6FAFE9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.499"
        d="M3 18.496a3.494 3.494 0 0 1 3.494-3.494h4.012A3.494 3.494 0 0 1 14 18.496m2-3.494h1.506A3.494 3.494 0 0 1 21 18.496"
      />
    </svg>
  </SvgIcon>
);
